import React, { useState } from "react";
import LibraryLogo from "../Library.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBars,
  faShoppingCart,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";

const Nav = ({ cartCount = 0 }) => {
  function openMenu() {
    setMenuOpen(true);
  }

  function closeMenu() {
    setMenuOpen(false);
  }
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav className={menuOpen ? "menu--open" : ""}>
      <div className="nav__container">
        <a href="/" onClick={closeMenu}>
          <img src={LibraryLogo} alt="Library Logo" className="logo" />
        </a>
        <div className="nav__menu">
          <ul className="nav__list">
            <li>
              <a href="/" className="nav__link">
                Home
              </a>
            </li>
            <li>
              <a href="/books" className="nav__link">
                Books
              </a>
            </li>
          </ul>
          <div className="nav__actions">
            <button className="btn__menu" onClick={openMenu}>
              <FontAwesomeIcon icon={faBars} />
            </button>
            <a href="/cart" className="nav__icon">
              <FontAwesomeIcon icon={faShoppingCart} />
              <span className="cart__length">{cartCount}</span>
            </a>
            <div className="menu__backdrop">
              <button
                className="btn__menu btn__menu--close"
                onClick={closeMenu}
              >
                <FontAwesomeIcon icon={faTimes} />
              </button>
              <ul className="menu__links">
                <li>
                  <a href="/" className="menu__list" onClick={closeMenu}>
                    Home
                  </a>
                </li>
                <li>
                  <a href="/books" className="menu__list" onClick={closeMenu}>
                    Books
                  </a>
                </li>
                <li>
                  <a href="/cart" className="menu__list" onClick={closeMenu}>
                    Cart
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Nav;
